import { gql } from "@apollo/client";
import { OderListFragment, ParcelInfoFragment } from "./fragments";

export const GET_PARCELS_BY_CLIENT = gql`
  query allParcelsByClient($params: ParcelsByClientFetchParams!, $queries: ParcelsByClientFetchQueries) {
    results: allParcelsByClient(params: $params, queries: $queries) {
      code
      error
      message
      countTotal
      currentPage
      totalPages
      parcels: data {
        ...ParcelInfo
      }
    }
  }

  ${ParcelInfoFragment}
`;

export const GET_ORDERS_BY_CLIENT = gql`
  query allOrdersByClient($params: OrdersByClientFetchParams!, $queries: OrdersByClientFetchQueries) {
    results: allOrdersByClient(params: $params, queries: $queries) {
      code
      error
      message
      countTotal
      currentPage
      totalPages
      orders: data {
        ...OderSimpleInfo
      }
    }
  }

  ${OderListFragment}
`;

